export default {
  page: 'Page',
  pages: 'Pages',
  verbose_page: 'une page',
  modules: 'Modules',
  general_info: 'Informations générales',

  status: 'État',
  internal_title: 'Titre interne',
  route_name: 'Nom de route',
  slug: 'Slug',
  meta_title: 'Titre meta',
  meta_description: 'Description meta',
  sections: 'Sections',
};
